const SET_SUBSCRIPTION_INFO = 'SET_SUBSCRIPTION_INFO'

export { SET_SUBSCRIPTION_INFO }
